import { Body4 } from '@cointracker/styleguide';
import { Button } from '@cointracker/styleguide/src/LoggedIn';
import { useTranslation } from 'react-i18next';
interface GatherCryptoContentProps {
  onClickPrimary: () => void;
}

export const GatherCryptoContent = ({
  onClickPrimary,
}: GatherCryptoContentProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-16">
      <Body4>
        {t(
          'navigation.tax_readiness.sheet.gather_crypto_content.description_1',
        )}
      </Body4>
      <Body4>
        {t(
          'navigation.tax_readiness.sheet.gather_crypto_content.description_2',
        )}
      </Body4>
      <div className="flex gap-10">
        <Button size="small" variant="highEmphasis" onClick={onClickPrimary}>
          {t('navigation.tax_readiness.sheet.gather_crypto_content.button')}
        </Button>
      </div>
    </div>
  );
};
